// src/components/intake/bodies/index.js
import AboutYouBody from "./AboutYouBody";
import AmountsBody from "./AmountsBody";
import ExclusiveBody from "./ExclusiveBody";
import MultiBody from "./MultiBody";
import RankBody from "./RankBody";
import TwoPartBody from "./TwoPartBody";

// One body per page kind (`pages[].kind` on the intake GET). The wizard and the
// Questions page render the same bodies.
export const BODIES = {
  rank: RankBody,
  multi: MultiBody,
  twoPart: TwoPartBody,
  multiExclusive: ExclusiveBody,
  amounts: AmountsBody,
  aboutYou: AboutYouBody,
};
